// @flow

import type { NotificationsState } from "./types";

export const initialState: NotificationsState = {
  error: null,
  requestsInProgress: 0,
  summary: null,
  notificationAudit: {
    list: {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
  },
  individuals: {
    recipient: {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
    target: {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
  },
  departments: {
    recipient: {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
    target: {
      content: [],
      pagination: {
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
      },
      totalElements: 0,
    },
  },
  modals: {
    individualsRevisionHistory: {
      visible: false,
      data: {
        content: [],
        pagination: {
          pageNumber: 0,
          pageSize: 0,
          offset: 0,
        },
        totalElements: 0,
      },
    },
    addNotification: {
      visible: false,
      editing: false,
      data: {
        employeeDetails: null,
        notificationDates: {
          activeFrom: null,
          activeTo: null,
        },
      },
      list: {
        content: [],
        pagination: {
          pageNumber: 0,
          pageSize: 0,
          offset: 0,
        },
        totalElements: 0,
      },
    },
    recipientPositions: [],
  },
  notificationSchema: null,
};

export default initialState;
